import { Component } from "@angular/core";
import {
  NavController,
  NavParams,
  ToastController,
  LoadingController,
  ModalController
} from "ionic-angular";
import { SelectPage, DetailImagePage } from "../";
import { Task, Schedule, Dokumen, Project } from "@providers/index";
import { DatePicker } from "@ionic-native/date-picker";
import { Camera, CameraOptions } from "@ionic-native/camera";

import { Utility } from "@providers/resources/utility";
import { Config } from "ionic-angular/config/config";

@Component({
  selector: "page-list-ar",
  templateUrl: "page.html"
})
export class ListAR {
  project_code = "";
  loading: any;
  dataSales: any = [];
  totalAmount = "-";

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private toastCtrl: ToastController,
    public datePicker: DatePicker,
    public loadingCtrl: LoadingController,
    public modalCtrl: ModalController,
    public projectApi: Project,
    public scheduleApi: Schedule,
    public dokumenApi: Dokumen,
    public camera: Camera,
    public config: Config,
    public utility: Utility
  ) {
    this.config.set("backButtonText", "List AR");
    this.project_code = this.navParams.get("project_code");
    this.getListAR();
    console.log("params",this.project_code);
  }

  showLoading() {
    this.loading = this.loadingCtrl.create({
      content: "Please wait..."
    });
    this.loading.present();
  }

  presentToast(msg) {
    this.toastCtrl
      .create({
        message: msg,
        duration: 3000,
        position: "top"
      })
      .present();
  }

  getListAR(){
    let params = {
      project_code: this.project_code
    };
    this.projectApi.getListAR(params).subscribe((resp:any) => {
      console.log(resp)
      if (resp.success) {
        this.dataSales = resp.data;
        this.totalAmount = resp.amount;
      }
    });
  }

  ionViewDidLeave(){
    this.config.set("backButtonText", "");
  }
}



// WEBPACK FOOTER //
// ./src/pages/project_mobile/list_ar/page.ts